<template>
  <router-view></router-view>
  <floatingChat v-if="isAuthenticated"></floatingChat>
</template>
<script>
import floatingChat from "./views/System/FloatingChat.vue";
import store from "@/store/index.js";
import { mapActions } from "vuex";
import { connect, disconnect, reconnect } from './views/System/statusWebsocket';
export default {
  components: {
    floatingChat
  },
  created() {
    connect();
  },
  computed: {
    isAuthenticated() {
      const isAuthenticated = store.getters['authStore/isLoggedIn'];
      return isAuthenticated;
    }
  },
  methods: {
    ...mapActions("authStore", ["reinitializeToken"]),
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        console.log("Tab became visible. Checking token...");
        store.dispatch("authStore/checkAndRefreshTokenIfNeeded");
        console.log("connecting ro websocket  connection in visibility changes method");
        reconnect();
      }
    },
    handleWindowFocus() {
      console.log("Window focused. Checking token...");
      store.dispatch("authStore/checkAndRefreshTokenIfNeeded");
      console.log("connecting ro websocket  connection in handleWindowFocus method");
      reconnect();
    },
  },
  mounted() {
    this.reinitializeToken();
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    window.addEventListener("focus", this.handleWindowFocus);
  },
  beforeDestroy() {
    disconnect();
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    window.removeEventListener("focus", this.handleWindowFocus);
  },
};
</script>
